'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Panel = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Panel = exports.Panel = (0, _systemComponents2.default)({
  bg: 'white',
  borderRadius: 2,
  border: 1,
  borderColor: 'gray'
}, {
  overflow: 'hidden'
}, 'space');

Panel.displayName = 'Panel';

Panel.Header = (0, _systemComponents2.default)({
  is: 'header',
  fontSize: 2,
  p: 2,
  bg: 'white',
  borderBottom: 1,
  borderColor: 'gray'
});

Panel.Header.displayName = 'Panel.Header';

Panel.Footer = (0, _systemComponents2.default)({
  is: 'footer',
  fontSize: 1,
  p: 2,
  bg: 'white',
  borderTop: 1,
  borderColor: 'gray'
});

Panel.Footer.displayName = 'Panel.Footer';

exports.default = Panel;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Panel.js
// module id = 513
// module chunks = 168707334958949